export const primaryButtonSx = (darkMode) => ({
    backgroundImage: darkMode
        ? "linear-gradient(to right bottom, #5a7386, #425563)"
        : "linear-gradient(to right bottom, #003586, #002D72)",
});
